import React from 'react';
import Image from 'next/image';
import Card from '@/designSystem/Card';
import { CAT } from '@/utils/assets';
import styles from './HeroMaxAgeCard.module.scss';

const HeroMaxAgeCard = () => {
  return (
    <div className={styles.hero_max_age_card_container}>
      <Card customClass={styles.hero_max_age_card}>
        <div className={styles.hero_max_age_card_content}>
          <Image
            src={CAT.CAT_CIRCLE}
            alt="ícono de gato"
            height={48}
            width={48}
            className={styles.hero_max_age_card_icon}
          />
          <div>
            <div className={styles.hero_max_age_card_title}>Protege a tu equipo hoy</div>
            <div className={styles.hero_max_age_card_text}>
              <span>
                Protege el bienestar de tus colaboradores con un seguro de salud y vida con
                contratación hasta los 70 años y cobertura de preexistencias
              </span>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default HeroMaxAgeCard;